// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__pQUSG","index":"styles_index__2z44N"};